import React, { useState } from 'react';

function Contacts(){
	const [discordCopied, setDiscordCopied] = useState(false);
	return (
		<div className='contacts bottom'>
			<a className='contact-button' href='https://github.com/Neondertalec' target='_blank'>
				<div>
					<img src="./github.svg"></img> Github
				</div>
			</a>
			<a className='contact-button' href='https://www.linkedin.com/in/viktor-lacinov-305a27274/' target='_blank'>
				<div>
					<img src="./linkedin.svg"></img> LinkedIn
				</div>
			</a>
			<a className='contact-button' href='https://replit.com/@DepressionOwU' target='_blank'>
				<div>
					<img src="./replit.svg"></img> Replit
				</div>
			</a>
			<a className='contact-button discord' target='_blank' onClick={()=>{navigator.clipboard.writeText("_ression");setDiscordCopied(true)}}>
				<div>
					<img src="./discord.svg"></img> <span>{discordCopied ? "Copied!" : "Discord"}</span>
				</div>
			</a>
		</div>
	)
}

export default Contacts;